export const inputStyles = {
    backgroundColor: "transparent",
    "&:hover": { backgroundColor: "transparent" }, // Ensure no background change
    "&.Mui-focused": { backgroundColor: "transparent" },
    "& .MuiFilledInput-root": {
        backgroundColor: "transparent",
        paddingRight: "15px",
        "&:before": {
            borderBottomColor: "gray",
            borderBottomWidth: "0.5px", // Thinner default border
            borderBottomStyle: "solid",
            opacity: 1,
        },
        "&:after": {
            borderBottomColor: "black",
            borderBottomWidth: "1px", // Thinner focus border
            borderBottomStyle: "solid",
        },
        "&:hover": {
            backgroundColor: "transparent", // Removes gray hover effect
        },
        "&:hover:not(.Mui-disabled, .Mui-error):before": {
            borderBottomColor: "black",
        },
    },
    "& .MuiFilledInput-inputMultiline": {
        paddingTop: "4px !important", // Override default excessive padding
        paddingBottom: "4px !important",
    },
    "&.Mui-focused .MuiFilledInput-root:after": {
        borderBottomColor: "black",
    },
};
